import app from '@/app';
import templateUrl from './organization-detail.html';

/* @ngInject */
function Controller($controller, Organization, User, Principal, $http, DialogService, $uibModal) {
	var $ctrl = this;
	$controller('AbstractEntityDetailController', {
		$ctrl: $ctrl,
		resource: Organization,
		type: null
	});

	$ctrl.selectAll = false;

	$ctrl.toggleSelectAll = function() {
		const isChecked = $ctrl.selectAll;
		if ($ctrl.entity && $ctrl.entity.roads) {
			$ctrl.entity.roads.forEach(function(road) {
				road.selectItem = isChecked;
			});
		}
	};

	$ctrl.selectedRoadsCount = function() {
		if ($ctrl.entity && $ctrl.entity.roads) {
			return $ctrl.entity.roads.filter(road => road.selectItem).length;
		}
		return 0;
	};

	const openRoadDeleteConfirmDialog = (roads) => {
		const ids = roads.map(road => road.id);
		return $http.post('api/roads/dependencies', ids).then(response => {
			return $uibModal.open({
				component: 'roadDeleteConfirmDialog',
				resolve: {
					bindings: () => ({ roads: roads, dependencies: response.data })
				}
			}).result;
		});
	};

	$ctrl.confirmDeleteSelected = () => {
		const selectedRoads = $ctrl.entity.roads.filter(road => road.selectItem);
		if (!$ctrl.readonly && selectedRoads.length > 0) {
			openRoadDeleteConfirmDialog(selectedRoads).then(() => $ctrl.removeSelectedRoads(selectedRoads));
		}
	};

	$ctrl.removeSelectedRoads = (selectedRoads) => {
		const selectedIds = selectedRoads.map(road => road.id);
		$ctrl.entity.roads = $ctrl.entity.roads.filter(road => !selectedIds.includes(road.id));
		$ctrl.selectAll = false;
		if ($ctrl.organizationForm && $ctrl.organizationForm.roads) {
			$ctrl.setDirty($ctrl.organizationForm.roads);
		}
	};

	$ctrl.confirmDeleteRoad = (road) => {
		if (!$ctrl.readonly) {
			openRoadDeleteConfirmDialog([road]).then(() => $ctrl.removeRoad(road.id));
		}
	};

	$ctrl.currentAccount = null;
  
	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});


	$ctrl.addChild('Road', 'roads', 'organizationForm');

	$ctrl.queryUsers = query => {
		if (query) {
			return User.all({ query: query }, data => ($ctrl.allUsers = data)).$promise;
		} else {
			return $http.get('/api/users').then(response => {
				const data = response.data;
				$ctrl.allUsers = Array.isArray(data) ? { content: data } : data;
			});
		}
	};

	// Load users initially so the template table is populated
	$ctrl.queryUsers();

	// Checks if the user is in the list of authorized users
	$ctrl.isAuthorized = function(user) {
		return $ctrl.entity.authorizedUsers &&
		$ctrl.entity.authorizedUsers.some(function(u) {
			return u.id === user.id;
		});
	};

	// Adds or removes the user from the list of authorized users
	$ctrl.toggleUser = function(user) {
		if (this.organizationForm) {
			this.organizationForm.$setDirty();
		}
		if (!$ctrl.entity.authorizedUsers) {
			$ctrl.entity.authorizedUsers = [];
		}

		const index = $ctrl.entity.authorizedUsers.findIndex(function(u) {
			return u.id === user.id;
		});

		if (index > -1) {
		// User is already in the list → remove it
			$ctrl.entity.authorizedUsers.splice(index, 1);
		} else {
		// User is not in the list → add it
			$ctrl.entity.authorizedUsers.push(user);
		}
	};
}

const component = {
	templateUrl,
	controller: Controller,
	bindings: {
		$transition$: '<',
		entity: '<',
		allUsers: '<'
	}
};

app.component('organizationDetail', component);
